<script>
export default {
  data () {
    return {
      airportCodeSet: [],
      airportNameSet: []
    }
  },
  methods: {
    loadAirport () {
      this.$axios
        .get('/search-airport')
        .then((res) => {
          const result = res.data.list
          const airportCodeSet = new Set()
          const airportNameSet = new Set()
          result.forEach((x) => {
            airportCodeSet.add(x.airport_code)
            airportNameSet.add(x.airport_name)
          })
          this.airportCodeSet = [...airportCodeSet]
          this.airportNameSet = [...airportNameSet]
          sessionStorage.setItem('airportCodeSet', JSON.stringify(this.airportCodeSet))
          sessionStorage.setItem('airportNameSet', JSON.stringify(this.airportNameSet))
        })
        .catch((e) => {
          console.log(e)
        })
    },
    refreshAirportAutocompleteList () {
      this.airportCodeSet = JSON.parse(sessionStorage.getItem('airportCodeSet'))
      this.airportNameSet = JSON.parse(sessionStorage.getItem('airportNameSet'))
    },
    getAirportCodeSet () {
      return JSON.parse(sessionStorage.getItem('airportCodeSet'))
    },
    getAirportNameSet () {
      return JSON.parse(sessionStorage.getItem('airportNameSet'))
    },
    margeAirportCodeSet (value) {
      const newAirportCodeSet = Array.isArray(value) ? [...value] : [value]
      const airportCodeSet = [...new Set([...JSON.parse(sessionStorage.getItem('airportCodeSet')),
        ...newAirportCodeSet])].sort()
      sessionStorage.setItem('airportCodeSet', JSON.stringify([...airportCodeSet]))
    },
    margeAirportNameSet (value) {
      const newAirportNameSet = Array.isArray(value) ? [...value] : [value]
      const airportNameSet = [...new Set([...JSON.parse(sessionStorage.getItem('airportNameSet')),
        ...newAirportNameSet])].sort()
      sessionStorage.setItem('airportNameSet', JSON.stringify([...airportNameSet]))
    }
  }
}
</script>
